import * as React from 'react';

/**
 * Get page visibility state as a React hook.
 */
export function usePageVisibility() {
    return React.useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

function getSnapshot() {
    return !document.hidden;
}

function subscribe(callback) {
    window.addEventListener('visibilitychange', callback);
    return () => {
        window.removeEventListener('visibilitychange', callback);
    };
}
